import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "card mb-5 mb-xl-8" }
const _hoisted_2 = {
  key: 2,
  class: "d-flex flex-column"
}
const _hoisted_3 = { class: "card-header align-items-center justify-content-between" }
const _hoisted_4 = { class: "card-title d-flex flex-row justify-content-between" }
const _hoisted_5 = { class: "card-label fw-bolder fs-3 mb-1" }
const _hoisted_6 = { class: "d-flex flex-row" }
const _hoisted_7 = ["disabled"]
const _hoisted_8 = {
  key: 0,
  class: "spinner-border spinner-border-sm align-middle me-2"
}
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" Save ")
const _hoisted_10 = { class: "card-body p-8" }
const _hoisted_11 = { class: "d-flex flex-column" }
const _hoisted_12 = { class: "d-flex flex-column mb-4" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("label", {
  for: "help-cat-dropdown",
  class: "form-label"
}, "Help category", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoadingSpinner = _resolveComponent("LoadingSpinner")!
  const _component_el_empty = _resolveComponent("el-empty")!
  const _component_HelpCategoriesDropdown = _resolveComponent("HelpCategoriesDropdown")!
  const _component_tinyMceEditor = _resolveComponent("tinyMceEditor")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.loading)
      ? (_openBlock(), _createBlock(_component_LoadingSpinner, { key: 0 }))
      : (!_ctx.loading && _ctx.helpArticle == null)
        ? (_openBlock(), _createBlock(_component_el_empty, {
            key: 1,
            description: "Could not find help article"
          }))
        : (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("h3", _hoisted_4, [
                _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.helpArticle.title), 1)
              ]),
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("button", {
                  class: "btn btn-sm btn-primary me-3",
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleBackButton && _ctx.handleBackButton(...args)))
                }, " Back "),
                _createElementVNode("button", {
                  disabled: _ctx.isSaving,
                  class: "d-flex align-items-center btn btn-sm btn-success",
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.saveArticle && _ctx.saveArticle(...args)))
                }, [
                  (_ctx.isSaving)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_8))
                    : _createCommentVNode("", true),
                  _hoisted_9
                ], 8, _hoisted_7)
              ])
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, [
                  _hoisted_13,
                  _createVNode(_component_HelpCategoriesDropdown, {
                    id: "help-cat-dropdown",
                    modelValue: _ctx.helpArticle.category_id,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.helpArticle.category_id) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", null, [
                  _createVNode(_component_tinyMceEditor, {
                    modelValue: _ctx.helpArticle.text,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.helpArticle.text) = $event))
                  }, null, 8, ["modelValue"])
                ])
              ])
            ])
          ]))
  ]))
}